import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useAccommodationMaster() {
  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [activeEditId, setActiveEditId] = useState(0);
  const { formatMessage } = useIntl();

  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const saveAccommodationMasterStatus = getStatus(state, apiKeys.saveAccommodationMaster, '');
  const updateAccommodationMasterStatus = getStatus(state, apiKeys.updateAccommodationMaster, '');
  const accommodationMasterData = getData(state, apiKeys.accommodationMaster, []);
  const accommodationMasterStatus = getStatus(state, apiKeys.accommodationMaster, '');
  const accommodationMasterErrMsg = getErrorMessage(state, apiKeys.accommodationMaster, '');
  const deleteAccommodationMasterStatus = getStatus(state, apiKeys.deleteAccommodationMaster, '');

  const getAccommodationMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.accommodationMaster,
      method: apiMethods.GET,
      key: apiKeys.accommodationMaster,
      failureMsg: formatMessage({ id: "failed-to-get-accommodation-master" }),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getAccommodationMaster()
  }, [dispatch, getAccommodationMaster]);

  useEffect(() => {
    if (deleteAccommodationMasterStatus === apiStatuses.succeeded) {
      getAccommodationMaster();
    }
  }, [deleteAccommodationMasterStatus, getAccommodationMaster])

  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.accommodationMaster }));
  }, [dispatch]);

  const onRowEdit = useCallback((id) => {
    setIsCreateEditModalOpen(true);
    setActiveEditId(id);
  }, [])
  const closeModal = useCallback(() => {
    setIsCreateEditModalOpen(false);
    setActiveEditId(0);
  }, []);

  
  useEffect(() => {
    if (saveAccommodationMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getAccommodationMaster();
    } 
  }, [saveAccommodationMasterStatus, closeModal, getAccommodationMaster]);

  useEffect(() => {
    if (updateAccommodationMasterStatus === apiStatuses.succeeded) {
      closeModal(); 
      getAccommodationMaster();
    } 
  }, [updateAccommodationMasterStatus, closeModal, getAccommodationMaster]);

  return useMemo(() => ({
    accommodationMasterData,
    accommodationMasterStatus,
    accommodationMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  }), [
    accommodationMasterData,
    accommodationMasterStatus,
    accommodationMasterErrMsg,
    isCreateEditModalOpen,
    setIsCreateEditModalOpen,
    onRowEdit,
    activeEditId,
    closeModal
  ])
}
